import Vue from 'vue';
import i18n from '@/libs/i18n';
import router from './router';
import store from './store';
import App from './App.vue';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { applyDesignFlag, installDesignStoreHooks, readCachedIsHesbaClient, resolvePreLoginDesign } from '@/libs/design';
import { isUserLoggedIn } from '@/auth/utils';

// Global Components
import './global-components';
// mixin
import './mixin/global';
import '@core/scss/vue/libs/vue-select.scss';

installDesignStoreHooks(store);

async function boot() {
  window.__HASBA_BOOTING__ = true;
  try {
    if (isUserLoggedIn()) {
      await applyDesignFlag(readCachedIsHesbaClient(), store);
    } else {
      await resolvePreLoginDesign(store);
    }
  } finally {
    window.__HASBA_BOOTING__ = false;
  }

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
}

boot();
